/**
 * Scripts
 */
import 'vite/modulepreload-polyfill'
import "lazysizes"
import { startupTheme } from "./js/theme"

// Import modules
import './js/slider'
import './js/toggle'
import './js/cookieBanner'
import './js/filter'
import './js/loadMore'
import './js/tabs'
import './js/space'
import './js/contentNav'
// Import node modules
// import 'swiper/css'
// import 'swiper/css/navigation'
// import 'swiper/css/pagination'

import './sass/main.sass'

/**
 * Start Theme
 */
startupTheme()
